import { render, staticRenderFns } from "./VendorRegister.vue?vue&type=template&id=7090d8d9"
import script from "./VendorRegister.vue?vue&type=script&lang=js"
export * from "./VendorRegister.vue?vue&type=script&lang=js"
import style0 from "./VendorRegister.vue?vue&type=style&index=0&id=7090d8d9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports